import React, { useState, useEffect } from 'react';
import './GroupsComponents.css';

import ChildrenTableShort from '../TableChildren';
import GroupTabsFull from './GroupsTabsFull';
import GroupTabs from './GroupsTabsShort';
import AttendanceGroup from '../Attendance/AttendanceTable';
import FoodRatesTable from '../KitchenTable/FoodRatesTable';
import StatisticaAttendanceGroup from '../TabelGroup/StatisticaAttendanceGroup';

import { getFreePlacesInfo } from '../helpers/freeplaces';

import imgDownSvg from '../../../../../img/arrow-down-fill.svg'

// Компонент группы
const GroupItem = ({ index, group, isExpanded, onToggle, children, isKgHead=false, onEditGroup, isArchive, mode }) => {

  const free_info= getFreePlacesInfo(group);


  const isHasPlanedInclusiveAmount = (group) =>{

    const { placesAmount, planedAmount} = group;

    return ["inclusive", "inclusiveShort"].filter(k=>placesAmount[k] || planedAmount[k]).length > 0;

  }


  const { free_places, places_amount, aval } = free_info; 

  return (
    <div className="groupskg-group-item">
      <div 
        className={`groupskg-group-header ${isExpanded ? 'groupskg-expanded' : 'groupskg-collapsed'}`}
        onClick={onToggle}
      >
        <div className="groupskg-group-header-content">
          <span className="groupskg-group-index">{index}</span>
          <div className="groupskg-group-title">{group.number} {group.name}</div>
          <div className="groupskg-group-actions">
            {isKgHead && <a href="" className="groupskg-link-primary groupskg-small groupskg-text-nowrap" onClick={(e)=>{ e.preventDefault(); onEditGroup(group._id) }}>
               {mode == "edit" ? 'Редагувати' : "Опис групи" }
            </a>}
            <a href="" className="groupskg-link-primary groupskg-small groupskg-text-nowrap" onClick={(e)=>e.preventDefault()}>
              {isExpanded ? 'Згорнути' : 'Детальніше'}
            </a>
            <img
              src={imgDownSvg}
              alt="expand"
              className={`groupskg-expand-icon ${isExpanded ? 'groupskg-expanded' : ''}`}
            />
          </div>
        </div>
        <div className="groupskg-group-head-text">
          <div className="groupskg-group-subtitle">
            {group.subtitle}
            <span className="groupskg-sep-dot"></span>
            {group.type}
          </div>
          <div className="groupskg-group-availability">
            <strong>{free_places['standart']}</strong> з{ ' ' }
            <strong>{places_amount['standart']}</strong> повного дня
            <span className="groupskg-sep-dot"></span>{' '}
            <strong>{free_places['without-bed']}</strong> з{' '}
            <strong>{places_amount['without-bed']}</strong> короткотривалого перебування
            <span className="groupskg-sep-dot"></span>{' '}
            {isHasPlanedInclusiveAmount(group) && <><strong>{free_places['inclusive'] + (free_places['inclusive-short'] || 0)}</strong> з{' '}
            <strong>{places_amount['inclusive'] + (places_amount['inclusive-short'] || 0) }</strong> інклюзивних місць</> || null}
            <span className={`groupskg-muted ${group.available ? 'groupskg-available' : 'groupskg-unavailable'}`}>
              {aval ? 'місця наявні' : 'місць немає'}
            </span>
          </div>
        </div>
      </div>
      
      {isExpanded && (
        <div className="groupskg-group-content">
          {children}
        </div>
      )}
    </div>
  );
};


// Компонент списка групп
export const GroupsList = ({ 
    groups, 
    isKgHead = false, 
    id, 
    onEditGroup, 
    onActionSelect, 
    period, 
    setCount, 
    isArchive,
    mode,
    onSelectedDate
   }) => {
  const [expandedGroup, setExpandedGroup] = useState(null);
  const [activeTab, setActiveTab] = useState('kids');
  const [selectedDate, setSelectedDate] = useState(isArchive ? `${period}-09-01` : new Date().toISOString());

  const handleGroupToggle = (groupId) => {
    setExpandedGroup(expandedGroup === groupId ? null : groupId);
  };

  useEffect(()=>{
    if(setCount && groups) setCount(groups.length > 0);
  },[period, groups])

  useEffect(()=>{
    setSelectedDate(isArchive ? `${period}-09-01` : new Date().toISOString());
  },[isArchive, period])

  useEffect(()=>{
    if(!onSelectedDate) return;
    onSelectedDate(selectedDate);
  },[selectedDate]);

  const Tabs = (props)=>{
    if(isKgHead) { 
      return GroupTabsFull(props)
    }
    else {
      return GroupTabs(props)
    } 
  }

  const get_obj_groups_info_row = ({ _id, number, name, type, typeNumber, periodStartYear })=>({_id, number, name, type, typeNumber, periodStartYear});

  //const prep_groups_transfer = groups?.filter(g=>period ? g.periodStartYear == period : true).map(gr=>get_obj_groups_info_row(gr));

  const prep_groups_transfer = groups;

  return (
    <div className="groupskg-groups-list">
      {groups?.map((group, index) => (
        <GroupItem
          key={group._id}
          group={group}
          isExpanded={expandedGroup === group._id}
          onToggle={() => handleGroupToggle(group._id)}
          index={index +1}
          onEditGroup={onEditGroup}
          isKgHead={isKgHead}
          isArchive={isArchive}
          period={period}
          mode={mode}
        >
          <div className="groupskg-teachers groupskg-small groupskg-text-muted groupskg-mb-2">
            Вихователі: <span className="groupskg-text-body-teachers">{group.educators.map((e)=>e.firstName).join(",")}</span>
          </div>

          <Tabs activeTab={activeTab} 
            onTabChange={setActiveTab} 
            periodStartYear={group.periodStartYear}
            selectedDate={selectedDate}
            onDateChange={setSelectedDate}
            mode={mode}
          >

            {activeTab === 'kids' && <ChildrenTableShort 
                id={id} 
                group_id={group._id}
                onActionSelect={onActionSelect}
                groupNumber={group.number}
                groupName={group.name}
                allGroups={prep_groups_transfer}
                isArchive={isArchive}
                period={period}
                selectedDate={selectedDate}
                mode={mode}
                />}
            {activeTab === 'attendance' && <AttendanceGroup
                gr_id={group._id}
                showIdGroup={group._id}
                KinderGarten={groups}
                closePar={()=>{}}
                kg_id={id}
                groups={groups}
                periodStartYear={group.periodStartYear}
                selectedDate={selectedDate}
                mode={mode}
            />}
            {activeTab === 'table' && <StatisticaAttendanceGroup
                kgId={id}
                group={group}
                periodStartYear={group.periodStartYear}
                selectedDate={selectedDate}
                isArchive={isArchive}
            />}
            {activeTab === 'tarifs' && <FoodRatesTable
              data={group.price}
            />}
          </Tabs>
        </GroupItem>
      ))}
    </div>
  );
};

// Основной компонент
const GroupsComponent = (onActionSelect) => {
 
  const groupsData = [
    {
      id: 1,
      index: 1,
      title: "2024-2025 Група «Квітки»",
      subtitle: "Старша група — від 5-ти до 6-ти років",
      type: "Загального розвитку (без спеціалізацій)",
      availability: {
        full: { current: 5, total: 20 },
        short: { current: 1, total: 4 },
        inclusive: { current: 1, total: 2 }
      },
      available: false,
      teachers: "Онищук Таіса Петрівна, Чуприна Анна Євгенівна",
      children: [
        {
          lastName: "Шевченко",
          firstName: "Тарас",
          middleName: "Григорович",
          birthDate: "15.10.2023",
          documentNumber: "ІІ-БК908367",
          enrollmentDate: "01.01.2025",
          placeType: "Повного дня",
          foodType: "Звичайний"
        }
        // ... другие дети
      ]
    }
    // ... другие группы
  ];

  return (
    <div className="groupskg-groups-container">
      <div className="groupskg-toolbar">
        <button className="groupskg-btn-gr groupskg-btn-primary groupskg-btn-add">
          <i className="fa fa-plus groupskg-me-2"></i>Додати групу
        </button>
        <input
          type="search"
          className="groupskg-form-control groupskg-search-input"
          placeholder="Швидкий пошук"
          aria-label="Швидкий пошук"
        />
      </div>

      <GroupsList groups={groupsData} onActionSelect={onActionSelect}/>
    </div>
  );
};

export default GroupsComponent;